const documentClarifications = {
  passport: {
    clientHelpText: "Please upload the director's passport",
    clientTooltip:
      "The requested passport must belong to the company director.\nPlease upload a valid copy of the director's passport.",
    managerTooltip: "Client will be asked to upload the director's passport",
    ariaLabel: "More information about passport requirement",
  },
};

export default documentClarifications;
